export default __webpack_public_path__ + "static/media/flag-18.79184172.gif";